import { render, staticRenderFns } from "./ShopList.vue?vue&type=template&id=9a08d96e&scoped=true&lang=pug&"
import script from "./ShopList.vue?vue&type=script&lang=ts&"
export * from "./ShopList.vue?vue&type=script&lang=ts&"
import style0 from "./ShopList.vue?vue&type=style&index=0&id=9a08d96e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a08d96e",
  null
  
)

export default component.exports